var scope_0 = require('D:/workspace/maybe-ts/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c456ec48636c68cc1fc3e691f6fc80a1.js').default;export default
        Object.assign({}, scope_0 )
    